/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Stringcontainsaspect10Inputs */

const de__class_stringcontainsaspect10 = /** @type {(inputs: _Class_Stringcontainsaspect10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beinhaltet`)
};

/**

* @param {_Class_Stringcontainsaspect10Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_stringcontainsaspect10 = /** @type {((inputs?: _Class_Stringcontainsaspect10Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Stringcontainsaspect10Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_stringcontainsaspect10(inputs)
});
export { _class_stringcontainsaspect10 as "_class_StringCONTAINSAspect" }